import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

export const PanelRoot = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  minWidth: 0,
}));
